import React from "react"
import { Link } from "gatsby"
import { useIntl } from "../hooks"
import { LogoOutline } from "../images"
import { routes } from "../helpers"
import colors from "../styles/theme/colors"

export default function CallToAction() {
  const { t } = useIntl()
  return (
    <>
      <div
        className="w-full h-30vh -mb-1 z-10"
        style={{
          background: `linear-gradient(-5deg, ${colors.bodyText} 49.5%, ${colors.bodyText} 0.5%, ${colors.white} 50%)`,
        }}
      />
      <div className="overflow-hidden bg-bodyText">
        <div className="mb-20 container flex">
          <div className="w-full ml-1/12 mr-1/12 laptop:w-6/12 laptop:pt-15">
            <div className="font-serif mb-1.5">
              <h3 className="text-h4 leading-h4 tracking-30 tablet:text-h3 tablet:leading-h3 tablet:tracking-30 laptop:text-h1 laptop:leading-h1 laptop:tracking-66 text-white">
                {t("Home__CallToAction--Heading")}
              </h3>
            </div>
            <div className="mb-5">
              <p className="text-white text-h6 tracking-h6 tracking-12">{t("Home__CallToAction--Desc")}</p>
            </div>

            <Link to={routes.requestDemo} className="btn btn-primary">
              {t("Global__RequestDemo")}
            </Link>
          </div>
          <div className="-mb-42 hidden phablet:w-0 laptop:block laptop:w-3/12 relative">
            <LogoOutline />
          </div>
        </div>
      </div>
    </>
  )
}
